







































































































import {ScrollButton} from "wings-ui-components";
import {Component} from "vue-property-decorator";
import {MessageCategoryItem} from "@/store/settings/message_categories/types";
import {Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import MessageCategoriesFilter from "@/components/Settings/MessageCategories/MessageCategoriesFilter.vue";

@Component({components: {MessageCategoriesFilter, ScrollButton}})
export default class MessageCategories extends BaseItemsPage<MessageCategoryItem> {

  @Getter("transports") transportsList: any;
  @Getter("messageCategories") messageCategoriesResponse: any;

  private is_show_filter = false;
  currentSort = "name";
  currentSortOrder = "desc";
  tableFields = ['name', 'transport', 'is_default'];

  getTransportName(transports: any, is_default: boolean): any {
    let transport: any = [];
    let is_default_transport: any = [];
    let transport_name = ''
    transports.forEach((e: any) => {
      transport_name = this.transportsList.find((t: any) => t.id === e.transport_id)?.name
      if (e.is_default == '1') {
        is_default_transport.push(transport_name)
      }
      transport.push(transport_name)
    })
    return is_default ? is_default_transport.length ? is_default_transport.join(', ') : '-' : transport.join(', ')
  }

  getData(): any {
    return this.messageCategoriesResponse;
  }
}
